import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { useTranslation } from "react-i18next";
import ToolsModal from "./ToolsModal";

function ToolsSelection(props) {
  const { t } = useTranslation();
  const [showToolsModal, setShowToolsModal] = useState(false);

  const handleToolSelect = (toolId) => {
    if (toolId === "copy") {
      props.copyItem();
    } else if (toolId === "selectall") {
      props.selectAll();
    } else if (toolId === "cut") {
      props.cutItem();
    } else if (toolId === "removeall") {
      props.removeAllObjects2();
    } else if (toolId === "paste") {
      props.pasteItem();
    } else if (toolId === "clone") {
      props.copyAndPasteItem();
    } else if (toolId === "flipX") {
      props.flipX();
    } else if (toolId === "flipY") {
      props.flipY();
    } else if (toolId === "ungroupItems") {
      props.ungroupItems();
    } else if (toolId === "erase") {
      props.setModeType("erase");
      props.changeAction(toolId);
      props.setEraseMode(true);
    } else if (toolId === "draw") {
      props.setModeType("draw");
      props.changeAction(toolId);
      props.setDrawMode(true);
    } else if (toolId === "perspective") {
      props.changePerspective(true);
    } else if (toolId === "grid") {
      props.drawGrid();
    } else {
      props.changeAction(toolId);
    }
  };

  return (
    <div className="d-inline dropup">
      {/* Tools Button - Toggles Tools Drawer */}
      <button
        className="btn mt-1 btn-block pb-0 m-0 btn-primary btn-sm"
        onClick={() => setShowToolsModal(!showToolsModal)}
      >
        <img
          className="toolsButton"
          src="/icons/tools.png"
          height="40px"
          alt="Tools"
          title={t("toolsSelection-tools")}
        />
      </button>

      {/* Tools Modal */}
      <ToolsModal
        show={showToolsModal}
        onHide={() => setShowToolsModal(false)}
        onToolSelect={handleToolSelect}
        title={t("toolsSelection-tools", "Tools")}
      />
    </div>
  );
}

export default ToolsSelection;
